export const blockIconsAndroidGppBadNew = (
	<span className='material-symbols-outlined'>gpp_bad</span>
);
